<template>
  <div class="basicInformation">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.LoadingReport.GENERAL_INFORMATION') }}
    </div>
    <!-- <div class="button-group">
      <a-button type="primary" size="small" @click="showModal">编辑</a-button>
    </div> -->
    <div class="basicInf-con">
      <ul>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.Client_Name') }}：</span
          >
          <span>{{ supervisionDetails.lreoprtClientname }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.Loadig_Address') }}：</span
          >
          <span>{{ supervisionDetails.lreoprtLoadigaddress }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.PO_Number') }}：</span
          >
          <span>{{ supervisionDetails.orderId }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.Item_Number') }}：</span
          >
          <span>{{ supervisionDetails.lreoprtItemnumber }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.Inspection_Started_at') }}：</span
          >
          <span>{{
            supervisionDetails.lreoprtInspectstartdate != null &&
            supervisionDetails.lreoprtInspectstartdate != ''
              ? $moment(supervisionDetails.lreoprtInspectstartdate).format(
                  'YYYY-MM-DD HH:mm',
                )
              : ''
          }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.Inspection_Completed_at') }}：</span
          >
          <span>{{
            supervisionDetails.lreoprtInspectenddate != null &&
            supervisionDetails.lreoprtInspectenddate != ''
              ? $moment(supervisionDetails.lreoprtInspectenddate).format(
                  'YYYY-MM-DD HH:mm',
                )
              : ''
          }}</span>
        </li>
      </ul>
      <ul>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.Inspector_s') }}：</span
          >
          <span>{{ supervisionDetails.lreoprtInspector }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.Container_Type') }}：</span
          >
          <span>{{ supervisionDetails.lreoprtConttype }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.Container_Condition') }}：</span
          >
          <span>{{ supervisionDetails.lreoprtContcondit }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.Container_No') }}：</span
          >
          <span>{{ supervisionDetails.lreoprtContno }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.LoadingReport.Seal_Number') }}：</span
          >
          <span>{{ supervisionDetails.lreoprtSealno }}</span>
        </li>
      </ul>
      <div class="prodeImg">
        <!-- <div v-if="productPhoto == undefined"></div>
        <div v-else-if="productPhoto.length == 0"></div>
        <div v-else>
          <img :src="config.urlImg + productPhoto[0].mediaPath" />
        </div>

        <p>{{ $tc('lang.LoadingReport.Loading_Finished_Photo') }}</p> -->
        <div class="img">
          <show-img
            :data="[productPhoto[0]]"
            :otherData="{
              mediaName: '',
              mediaType: '',
              personId: '',
              orderId: '',
              reportId: '',
              mediaDesc: '',
            }"
            :id="id"
          ></show-img>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import showImg from './showImg';
export default {
  name: 'descriptionOfGoods',
  data() {
    return {
      id: this.$route.query.id,
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),

      // loading: false,
      imageUrl: '',
      productPhotoList: [],
      otherData: {
        mediaName: '大货装柜完成照片',
        mediaType: 3,
        personId: '',
        orderId: '',
        reportId: '',
        mediaDesc: 'productPhoto',
      },
    };
  },
  computed: {
    supervisionDetails: {
      get() {
        return this.$store.state.report.supervisionDetails;
      },
      set(val) {
        this.$store.commit('report/save', { supervisionDetails: val });
      },
    },
    productPhoto: {
      get() {
        return this.$store.state.report.supervisionImgList.productPhoto;
      },
      // set(val) {
      //   this.$store.commit('report/save', { imgList: val });
      // },
    },
  },
  methods: {
    getDetail() {
      this.$http
        .post('/hzwmj/workorder-loadigreport/getData', {
          id: this.id,
        })
        .then(data => {
          if (data) {
            this.supervisionDetails = data;
          } else {
            this.supervisionDetails = {};
          }
        })
        .catch(() => {
          this.supervisionDetails = {};
        });
    },
    handleCancel() {
      this.productPhotoList = [];
      this.visible = false;
    },
  },
};
</script>
<style lang="less">
.basicInformation {
  .basicInf-con {
    display: flex;
    .basicInf-p1 {
      display: inline-block;
      width: 120px;
    }
    > ul {
      width: 40%;
      li {
        line-height: 40px;
      }
    }
    > div {
      width: 20%;
      text-align: center;
      // img {
      //   width: 60%;
      //   margin: 50px 0 10px 0;
      // }
    }
  }
  // .prodeImg > div {
  //   display: inline-block;
  //   width: 160px;
  //   height: 120px;
  //   border: 1px solid rgb(202, 202, 202);
  //   text-align: center;
  //   margin: 10px;
  //   overflow: hidden;
  //   margin-top: 30px;
  //   img {
  //     max-width: 100%;
  //     max-height: 100%;
  //   }
  // }
}
.basicinf-updataForm {
  .ant-form-item {
    width: 50%;
    display: inline-block;
    .ant-form-item-label {
      text-align: left;
    }
  }
}
</style>
